import { legacySelectStyle } from "@repo/ui/Select/select";
import { IconCheck, IconSelector } from "@tabler/icons-react";
import type { FC } from "react";
import {
  Button,
  ListBox,
  ListBoxItem,
  Popover,
  Select,
  SelectValue,
} from "react-aria-components";
import type { AudioPlayerSource } from "./context.js";

export interface AudioPlayerSourceSelectProps {
  sources: readonly AudioPlayerSource[];
  selectedKey: string | null;
  onSelectionChange: (key: string | null) => void;
}

export const AudioPlayerSourceSelect: FC<AudioPlayerSourceSelectProps> = (
  props,
) => {
  return (
    <Select
      className="disabled:invisible"
      aria-label="Selected call"
      placeholder="Select a call"
      isDisabled={props.sources.length === 0}
      selectedKey={props.selectedKey}
      onSelectionChange={(key) =>
        props.onSelectionChange(typeof key === "string" ? key : null)
      }
    >
      <Button className="group flex items-center justify-stretch gap-2 rounded-md px-3 py-1.5 text-left select-none hover:bg-gray-100 focus:ring-2 focus:ring-indigo-600 focus:outline-hidden disabled:cursor-not-allowed disabled:opacity-50">
        <SelectValue>
          {({ defaultChildren, isPlaceholder }) =>
            isPlaceholder ? (
              <div className="flex h-10 items-center text-sm text-muted-foreground">
                <div>{defaultChildren}</div>
              </div>
            ) : (
              defaultChildren
            )
          }
        </SelectValue>
        <IconSelector
          className={legacySelectStyle().chevron({
            className: "-mr-1 flex-none group-hover:text-muted-foreground",
          })}
        />
      </Button>

      <Popover
        className={legacySelectStyle().popover({
          className: "min-w-(--trigger-width)",
        })}
      >
        <ListBox items={props.sources} disallowEmptySelection>
          {(source) => (
            <ListBoxItem
              key={source.key}
              className="group/item cursor-pointer px-3 py-2 select-none hover:bg-gray-100"
            >
              <div className="grid grid-flow-col grid-cols-[minmax(0,1fr)_auto] grid-rows-[1fr_1fr] items-center">
                <div className="truncate text-sm font-medium">
                  {source.title}
                </div>

                <div className="truncate text-xs text-gray-600">
                  {source.subtitle}
                </div>

                <div className="row-span-full">
                  <IconCheck className="invisible ml-2 hidden size-5 shrink-0 text-indigo-600 group-data-[react-aria-pressable]/item:block group-selected/item:visible" />
                </div>
              </div>
            </ListBoxItem>
          )}
        </ListBox>
      </Popover>
    </Select>
  );
};
